import React, { useState } from "react";
import appIcon from "../../assets/images/logo/principal-app-icon.png";

/*
 * On-device preview, mirroring the preview panel of the Firebase console.
 * Indicative only — the real thing depends on the OS and the app version.
 *
 * Shows the OS notification popup (Android / iOS) as it appears outside the app.
 */
function DevicePreview({ title, body, imageUrl }) {
  const [platform, setPlatform] = useState("android");

  const previewTitle = title || "Notification title";
  const previewBody = body || "Notification message will show here";

  const hideOnError = event => {
    event.target.style.display = "none";
  };
  const hideIconOnError = event => {
    event.target.style.visibility = "hidden";
  };

  return (
    <div className="push-noti-preview">
      <div className="push-noti-preview-tabs">
        <button
          type="button"
          className={platform === "android" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("android")}
        >
          ANDROID
        </button>
        <button
          type="button"
          className={platform === "ios" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("ios")}
        >
          iOS
        </button>
      </div>

      <div className="push-noti-preview-device">
        <div className="push-noti-preview-screen">
          {/* Android reuses the iOS card layout for now. */}
          <div className="push-noti-card push-noti-card-ios">
            <img className="push-noti-card-ios-icon" src={appIcon} alt="" onError={hideIconOnError} />
            <div className="push-noti-card-ios-main">
              <div className="push-noti-card-ios-head">
                <p className="push-noti-card-title">{previewTitle}</p>
                <span className="push-noti-card-time">now</span>
              </div>
              {/* Real pushes truncate a long body: iOS keeps ~5 lines, Android ~4, then an ellipsis. */}
              <p className={`push-noti-card-body push-noti-card-body--${platform}`}>{previewBody}</p>
              {imageUrl ? (
                <img className="push-noti-card-image" src={imageUrl} alt="notification" onError={hideOnError} />
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <p className="push-noti-preview-note">Preview for rough layout only</p>
    </div>
  );
}

export default DevicePreview;
